import { Dropdown, Form, StrictDropdownProps } from "semantic-ui-react";

export type FilterSelectProps = Omit<
  StrictDropdownProps,
  "id" | "name" | "multiple" | "value" | "onChange"
> & {
  name: string;
  label: string;
  ariaLabel?: string;
  value: string;
  onChange: (value: string) => void;
};

const FilterSelect = ({
  name,
  label,
  ariaLabel,
  placeholder,
  value,
  onChange,
  ...dropdownProps
}: FilterSelectProps) => (
  <Form.Field inline>
    <label htmlFor={name}>{label}</label>
    <Dropdown
      clearable
      selection
      id={name}
      name={name}
      aria-label={ariaLabel ?? label}
      placeholder={placeholder ?? label}
      value={value}
      onChange={(_, data) => onChange((data.value as string) ?? "")}
      {...dropdownProps}
    />
  </Form.Field>
);

export default FilterSelect;
